import React from 'react';

const tick = (
  <div className="tick">
    <i className="sa sa-tick" />
  </div>
);

function SuccessConfirmationOverlay({ content = tick, background = 'rgba(255,255,255, 1)' }) {
  return (
    <div
      className="success-confirmation-overlay"
      style={{ background }}
    >
      {content}
    </div>
  );
}


export default SuccessConfirmationOverlay;



// WEBPACK FOOTER //
// ./src/parts/SuccessConfirmationOverlay.js